import { useCallback, useState } from 'react';

import { ICameraVideoTrack } from 'agora-rtc-react';

import Button from "@ergeon/core-components/exports/Button.ts";
import { useVirtualBackgroundExtension } from '@/app/extensions/VirtualBackground/context';

import { SparklesIcon } from "@heroicons/react/24/outline";
import { EVENTS, gtag } from '@/lib/gtag';

export interface ButtonVirtualBackgroundProps {
  localCameraTrack: ICameraVideoTrack;
}

export default function ButtonVirtualBackground({ localCameraTrack }: ButtonVirtualBackgroundProps) {
  const [isVirtualBGEnabled, setVirtualBGEnabled] = useState(true);

  const { isCompatible } = useVirtualBackgroundExtension({ track: localCameraTrack }, isVirtualBGEnabled);

  const toggleVirtualBG = useCallback(() => {
    gtag(EVENTS.TOGGLE_VIRTUAL_BACKGROUND);

    setVirtualBGEnabled(isVirtualBGEnabled => !isVirtualBGEnabled);
  }, []);


  return (
    <Button
      disabled={!isCompatible}
      flavor="regular"
      isActive={isVirtualBGEnabled}
      isSquare
      shape="circle"
      onClick={toggleVirtualBG}
      size="large"
      title="Enable virtual background">
      <SparklesIcon className="size-6" />
    </Button>
  );
}
